"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __importStar(require("../Behaviours/BehaviourRegistry"));
var Schemas_1 = __importDefault(require("../Schemas/Schemas"));
var ToolbarButtons_1 = require("../Widgets/ToolbarButtons");
var quote = {
    toolbarConfiguration: (0, ToolbarButtons_1.configureToolbarButtons)(["heading2", "bold", "italic", "strikethrough"]),
    registerBehaviours: function (di, router) {
        Registry.registerCursorValidationBehaviours(di, router);
        Registry.registerHeadingBehaviours(di, router);
        Registry.registerCommonBehaviours(di, router);
        Registry.registerToolbarBehaviours(di, router);
        Registry.registerPasteBehaviours(di, router);
        Registry.registerLinkBehaviours(di, router);
        Registry.registerShortcutBehaviours(di, router);
        Registry.registerVariableBehaviours(di, router);
        Registry.registerClickToAddBehaviours(di, router);
    },
    disableWidgetAdder: true,
    disableWidgetDragAndDrop: true,
    schema: (0, Schemas_1.default)("quotePlanCard"),
};
exports.default = quote;
